import { AssignedUser } from '@deltek/specification-client/core/Models/listing'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

const CheckboxFilterStyles = makeStyles((theme: Theme) => ({
    label: {
        color: theme.palette.common.white,
        margin: theme.spacing(0.625),
        fontSize: pxToRem(14),
        marginLeft: theme.spacing(1.25),
        fontWeight: 300,
    },
    checkbox: {
        display: 'none',
    },
    useList: {
        background: '#5E5F61',
        width: 240,
        paddingLeft: theme.spacing(1.25),
        paddingBottom: theme.spacing(0.625),
        borderRadius: 5,
        borderColor: '#5E5F61',
        maxHeight: 600,
        overflowY: 'auto',
        flexWrap: 'unset',
    },
    topLabel: {
        fontSize: pxToRem(20),
        marginTop: theme.spacing(1),
        color: theme.palette.common.white,
        textTransform: 'uppercase',
    },
    topLabelUnderLine: {
        border: '1px solid white',
        width: 220,
        marginLeft: 0,
    },
}))

export interface AssignedUserListProps {
    items: Partial<AssignedUser>[]
    buttonVariant: 'Deltek' | 'BPM'
}

const AssignedUserList: React.FC<AssignedUserListProps> = ({
    items,
    buttonVariant,
}) => {
    const styles = CheckboxFilterStyles()

    return (
        <FormGroup className={styles.useList}>
            <span className={styles.topLabel}>{buttonVariant} Assigned</span>
            <hr className={styles.topLabelUnderLine}></hr>
            {items.map((item, index) => (
                <FormControlLabel
                    key={index}
                    data-testid="unchanged-list"
                    classes={{ label: styles.label }}
                    control={
                        <Checkbox
                            data-testid={`checkbox-test`}
                            color="default"
                            checked={true}
                            className={styles.checkbox}
                        />
                    }
                    label={`${item?.profileInfo?.firstName} ${item?.profileInfo?.lastName} - ${item?.role}`}
                />
            ))}
        </FormGroup>
    )
}

export default AssignedUserList
